/*
 * @Author: redu842 2150673512@qq.com
 * @Date: 2024-07-09 15:47:34
 * @LastEditors: redu842 2150673512@qq.com
 * @LastEditTime: 2024-07-09 16:23:59
 * @FilePath: \wind\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import L from "leaflet"
import "leaflet/dist/leaflet.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';
Vue.prototype.$axios = axios //全局注册，使用方法为:this.$axios
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
